import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';

import { USER_LIST_MODIFICATION } from '../../../shared/constants';
import { AlertUtils, checkIfCanDelete, ParamUtils } from '../../../shared';
import { UserService, Principal } from '../../../services';
import { Account, User } from '../../../models';
import { PopupComponent } from '../../popup-component';

@Component({
    selector: 'qms-user-delete',
    templateUrl: './user-delete.component.html'
})
export class UserDeleteComponent {

    public model: User;

    constructor(private activeModal: NgbActiveModal,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService,
                private userService: UserService) {
    }

    public clear() {
        this.activeModal.dismiss('cancel');
    }

    public confirmDelete() {
        this.userService.delete(this.model.login).subscribe(() => {
            this.activeModal.close();
            this.eventManager.broadcast({
                name: USER_LIST_MODIFICATION,
                content: 'Deleted',
                modelId: this.model.id
            });
            AlertUtils.notifySuccess(this.eventManager, this.alertService,
                'user.deleted', { param: this.model.login });
        });
    }

}

@Component({
    selector: 'qms-user-delete-popup',
    template: ''
})
export class UserDeletePopupComponent extends PopupComponent<User, UserService> implements OnInit {
    private model: User;

    constructor(router: Router,
                route: ActivatedRoute,
                modalService: NgbModal,
                eventManager: JhiEventManager,
                alertService: JhiAlertService,
                userService: UserService,
                private principal: Principal) {
        super(router, route, modalService, eventManager, alertService, userService);
    }

    ngOnInit() {
        this.routeParamsSubscription = this.route.params.subscribe((params) => {
            ParamUtils.parseString(params['login'], (login: string) => {
                this.routeDataSubscription = this.route.data.subscribe((data) => {
                    const modalComponent = data['modalComponent'];
                    this.modelService.find(login).subscribe((model: User) => {
                        this.model = model;
                        this.principal.identity().then((account: Account) => {
                            if (this.checkIfAuthorized(account)) {
                                this.openModal(modalComponent, model);
                            }
                        });
                    });
                });
            }, () => {
                AlertUtils.notifyNotFound(this.eventManager, this.alertService);
                this.closeModal(true);
            });
        });
        this.routeQueryParamsSubscription = this.route.queryParams.subscribe((params) => {
            this.redirectUrl = params['redirectUrl'];
        });
    }

    private checkIfAuthorized(account: Account): boolean {
        return checkIfCanDelete(this.model, account);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/users/user-delete.component.ts